import React from 'react';
import { withRouteData } from 'react-static';
import {
  TwoColScrollLayout,
  TwoColStickyLayout,
  TwoColContentLayout,
  ContentWrapper,
  PageTitle,
  FlowStripeWrapper
} from '@flow/components/ui';
import { IPage } from 'types/IPage';
import FlowStripe from '@flow/components/ticker/FlowStripe';
import * as NavigationAction from '@flow/store/navigation/actions';
import { connect } from 'react-redux';
import SEOTags from '@flow/components/seo/SEOTags';
import { renderContent, renderImageCarousel } from '@flow/scenes/default/ui';
import Partners from '@flow/components/partners/Partners';
import { IPartners } from 'types/IPartners';
import { IOptions } from 'types/IOptions';
import styled from 'styled-components';

const PartnersWrapper = styled.div`
  margin: 5em 0;
`;

interface Props {
  appLanguage: IAppLanguage;
  options: IOptions;
  page: IPage;
  partners: IPartners;
  _setLanguage: any;
}

class PartnersPage extends React.Component<Props> {

  componentWillMount() {
    const {
      appLanguage,
      _setLanguage,
      page: {
        lang_versions
      }
    } = this.props;

    _setLanguage({ appLanguage, lang_versions });
  }

  componentWillReceiveProps({
    appLanguage,
    page: {
      lang_versions,
    }
  }: Props) {
    const {
      _setLanguage,
    } = this.props;
    _setLanguage({ appLanguage, lang_versions });
  }

  render() {
    const {
      appLanguage,
      partners,
      page: {
        title,
        images,
        content_group
      }
    } = this.props;

    const { page } = this.props;

    return (
      <TwoColScrollLayout>
        <SEOTags page={page}/>
        <TwoColStickyLayout>
          {renderImageCarousel(images)}
        </TwoColStickyLayout>
        <TwoColContentLayout>
          <FlowStripeWrapper>
            <FlowStripe rotation={90} color={'#000000'} />
          </FlowStripeWrapper>
          <ContentWrapper>
            {title &&
              <PageTitle>{title}</PageTitle>
            }
            {renderContent(content_group)}
            {partners && partners.length > 0 &&
              <PartnersWrapper>
                <Partners
                    appLanguage={appLanguage}
                    partners={partners}
                />
              </PartnersWrapper>
            }
          </ContentWrapper>
        </TwoColContentLayout>
      </TwoColScrollLayout>
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    _setLanguage: ({ appLanguage, lang_versions }: ISetLanguage) => {
      dispatch(NavigationAction.setLanguage(appLanguage, lang_versions));
    }
  }
};

export default connect(
  null,
  mapDispatchToProps
)(withRouteData(PartnersPage));



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/partners/PartnersPage.tsx